import { render, staticRenderFns } from "./EditPanelNoteDialog.vue?vue&type=template&id=9b1ac3a0&lang=pug&"
import script from "./EditPanelNoteDialog.vue?vue&type=script&lang=js&"
export * from "./EditPanelNoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports